export default __webpack_public_path__ + "static/media/tunica-blanca-mujer.e09727b6.png";